// extracted by mini-css-extract-plugin
module.exports = {"link":"_3vckfz"};